import { Component, OnInit, ViewChild } from '@angular/core';
import { OnboardingService } from '@boxx/onboarding-core/lib/services/onboarding.service';
import { IonSearchbar, PopoverController } from '@ionic/angular';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';

@Component({
  selector: 'app-custom-generic-picker',
  templateUrl: 'custom-generic-picker.component.html',
  styleUrls: ['./custom-generic-picker.page.scss']
})
export class CustomGenericPickerComponent implements OnInit {
  @ViewChild('customPickerSB', { static: false })
  searchBar: IonSearchbar;
  searchResults: any[] = [];
  searchFullResults: any[] = [];
  noResultsFound = false;
  isLoading = false;
  searchFilter = '';
  customTitle: string;
  customList: any[] = [];
  keyField: string;
  searchLabel: string;

  constructor(
    public popoverController: PopoverController,
  ) {
  }

  ngOnInit() {
    setTimeout(() => {
      this.searchBar.setFocus();
    }, 800);
    this.searchResults = this.customList;
    this.searchFullResults = this.customList;
  }

  search(ev: any) {
    const searchTerm = ev.detail.value;
    
    if (!searchTerm) {
      this.searchResults = this.searchFullResults;
      return;
    }
  
    this.searchResults = this.searchResults.filter(
      (item) =>
        item[this.keyField].toLowerCase().indexOf(searchTerm.toLowerCase()) > -1
    );
  }

  selectItem(item: any) {
    this.popoverController.dismiss({
      data: item
    });
  }

  close(){
    this.popoverController.dismiss();
  }
}